import { DoubleLeftOutlined, DoubleRightOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons'
import { preventMouseEvent } from '../../utils'
import { Button } from 'antd'

const getDisplayedNUmbers = ({
  selectedPage,
  totalPage,
  numberDisplayedIndex
}: {
  selectedPage: number
  totalPage: number
  numberDisplayedIndex: number
}) => {
  const listDisplayedNumber = [selectedPage]
  let start = 1
  while (true) {
    if (listDisplayedNumber.length >= numberDisplayedIndex) {
      break
    }
    if (selectedPage - start >= 0) {
      listDisplayedNumber.unshift(selectedPage - start)
    }
    if (listDisplayedNumber.length >= numberDisplayedIndex) {
      break
    }
    if (selectedPage + start < totalPage) {
      listDisplayedNumber.push(selectedPage + start)
    }
    start++
    if (start >= totalPage) {
      break
    }
  }
  return listDisplayedNumber
}

const PaddingComponent = (props: {
  className: string
  onSelectIndex: (index: number) => void
  selectedPage: number
  totalPage: number
  numberDisplayedIndex?: number
}) => {
  const displayedNUmbers = getDisplayedNUmbers({
    selectedPage: props.selectedPage,
    totalPage: props.totalPage,
    numberDisplayedIndex: props.numberDisplayedIndex || 5
  })

  const onSelectPage = (pageNumber: number) => {
    if (pageNumber >= 0 && pageNumber <= props.totalPage - 1) {
      props.onSelectIndex(pageNumber)
    }
  }

  return (
    <ul className={`${props.className} padding-area`}>
      <Button
        onClick={preventMouseEvent(onSelectPage.bind(null, 0))}
        className={`padding-item ${props.selectedPage <= 0 ? 'disabled' : ''}`}
      >
        <DoubleLeftOutlined />
      </Button>
      <Button
        onClick={preventMouseEvent(onSelectPage.bind(null, props.selectedPage - 1))}
        className={`padding-item ${props.selectedPage <= 0 ? 'disabled' : ''}`}
      >
        <LeftOutlined />
      </Button>
      {displayedNUmbers.map((pageIndex) => (
        <Button
          onClick={preventMouseEvent(onSelectPage.bind(null, pageIndex))}
          key={pageIndex}
          className={`padding-item ${pageIndex === props.selectedPage ? 'selected' : ''}`}
        >
          {pageIndex + 1}
        </Button>
      ))}
      <Button
        onClick={preventMouseEvent(onSelectPage.bind(null, props.selectedPage + 1))}
        className={`padding-item ${props.selectedPage >= props.totalPage - 1 ? 'disabled' : ''}`}
      >
        <RightOutlined />
      </Button>
      <Button
        onClick={preventMouseEvent(onSelectPage.bind(null, props.totalPage - 1))}
        className={`padding-item ${props.selectedPage >= props.totalPage - 1 ? 'disabled' : ''}`}
      >
        <DoubleRightOutlined />
      </Button>
    </ul>
  )
}

export default PaddingComponent
